module.exports = __webpack_public_path__ + "static/media/dragon3.07794997.png";